function toPositiveInt(v: unknown): number | null {
    if (v == null || v === '') return null;
    const n = typeof v === 'number' ? v : Number(v);
    return Number.isFinite(n) && n > 0 ? n : null;
}

function resolvePartyGlId(o: Record<string, unknown>): number | null {
    return toPositiveInt(
        o.partyPayableGlAccountId ??
            o.PartyPayableGlAccountId ??
            o.partyGLID ??
            o.PartyGLID
    );
}

function resolveCommissionGlId(o: Record<string, unknown>): number | null {
    return toPositiveInt(
        o.commissionGlAccountId ??
            o.CommissionGlAccountId ??
            o.commissionAccountGLID ??
            o.CommissionAccountGLID
    );
}

function resolvePaymentTermId(o: Record<string, unknown>): number | null {
    return toPositiveInt(o.paymentTermId ?? o.PaymentTermId ?? o.paymentTermID ?? o.PaymentTermID);
}

/** Normalize vendor API rows for react-admin (id + camelCase GL ids). */
export function normalizeVendorRecord(row: unknown): Record<string, unknown> {
    const o =
        row && typeof row === 'object' && !Array.isArray(row)
            ? { ...(row as Record<string, unknown>) }
            : {};
    const rawId = o.id ?? o.Id ?? o.partyId ?? o.PartyID;
    const id =
        rawId != null && rawId !== ''
            ? typeof rawId === 'number'
                ? rawId
                : Number(rawId)
            : undefined;

    const partyPayableGlAccountId = resolvePartyGlId(o);
    const commissionGlAccountId = resolveCommissionGlId(o);
    const paymentTermId = resolvePaymentTermId(o);

    return {
        ...o,
        ...(id !== undefined && Number.isFinite(id) ? { id } : {}),
        partyPayableGlAccountId,
        commissionGlAccountId,
        paymentTermId,
        partyGLID: partyPayableGlAccountId,
        commissionAccountGLID: commissionGlAccountId,
        paymentTermID: paymentTermId,
        partyType: o.partyType ?? o.PartyType ?? 1,
    };
}

/** Payload sent to POST/PUT /api/vendors — coerce GL ids and strip UI-only fields. */
export function transformVendorWrite(data: Record<string, unknown>): Record<string, unknown> {
    const {
        subPartyLines: _subPartyLines,
        businessLogoPreview: _logoPreview,
        ...fields
    } = data;

    const partyGLID = resolvePartyGlId(fields);
    const commissionAccountGLID = resolveCommissionGlId(fields);
    const paymentTermID = resolvePaymentTermId(fields);

    return {
        ...fields,
        partyPayableGlAccountId: partyGLID,
        commissionGlAccountId: commissionAccountGLID,
        paymentTermId: paymentTermID,
        partyGLID,
        commissionAccountGLID,
        PartyGLID: partyGLID,
        CommissionAccountGLID: commissionAccountGLID,
        paymentTermID,
        PaymentTermID: paymentTermID,
        partyType:
            fields.partyType != null && fields.partyType !== ''
                ? Number(fields.partyType)
                : fields.PartyType != null
                  ? Number(fields.PartyType)
                  : 1,
    };
}
